import React, {Component} from 'react';
import Modal from '@homeaway/react-modal';
import {Button} from '@homeaway/react-buttons';
import PreviewInviteModal from './preview-invite-modal';
import edap from '../edap';
import TestExposureOnce from '../../../abacus/test-exposure-once';
import {HA_PULSE_INVITE_ACCEPT_MODAL_TEST} from '../../../abacus/experiments';
export const testExposureInviteModal = new TestExposureOnce(HA_PULSE_INVITE_ACCEPT_MODAL_TEST);
import './error-invite-modal.less';

const closeTypes = {
    skip: 'skip',
    close: 'close'
};

class ErrorInviteModal extends Component {
    constructor(props) {
        super(props);
        this.handleClose = this.handleClose.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.state = {
            isOpen: true
        };
    }

    componentDidMount = () => {
        const {invitationId, boardId} = this.props;

        edap.expiredInviteModalPop(invitationId, boardId);
    };

    closeModal() {
        testExposureInviteModal.trigger(HA_PULSE_INVITE_ACCEPT_MODAL_TEST);
        this.setState({
            isOpen: false
        });
    }

    handleClose(closeType) {
        const {invitationId, boardId} = this.props;
        if (closeType === closeTypes.close) {
            return () => {
                edap.expiredInviteModalClose(invitationId, boardId);
                this.closeModal();
            };
        }

        return () => {
            edap.expiredInvitePublicTripboardViewClick(invitationId, boardId);
            this.closeModal();
        };
    }

    render() {
        const {
            titleText,
            bodyText,
            skipText,
            noPropertiesText,
            propertiesText,
            unitsCount,
            stay,
            tripBoard
        } = this.props;
        const isOpen = this.state.isOpen;
        return (
            <Modal id={'accept-invite-modal'} isOpen={isOpen} onClose={this.handleClose(closeTypes.close)}>
                <div className="error-invite-modal">
                    <div className="error-invite-modal__header header--columLayout">
                        <div>
                            <h2>{titleText}</h2>
                        </div>
                    </div>
                    <PreviewInviteModal {...{noPropertiesText, propertiesText, unitsCount, stay, tripBoard}} />
                    <div className="error-invite-modal__content">
                        <div className="error-invite-modal__header header--rowLayout">
                            <div>
                                <h2>{titleText}</h2>
                            </div>
                        </div>
                        <div className="error-invite-modal__body">
                            <div className="error-invite-modal__body-copy">{bodyText}</div>
                            <div className="error-invite-modal__exit">
                                <Button
                                    className="error-invite-modal__btn"
                                    onClick={this.handleClose(closeTypes.skip)}
                                    label={skipText}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

export default ErrorInviteModal;



// WEBPACK FOOTER //
// ./src/universal/tripboard/collaborate/components/error-invite-modal.js